export const GET_STARASSIGNMENT_LIST= "GET_STARASSIGNMENT_LIST"
export const GET_STARTYPES_LIST= "GET_STARTYPES_LIST"
export const GET_STARASSIGNMENT_TYPE_CATEGORY = "GET_STARASSIGNMENT_TYPE_CATEGORY"
export const GET_STATE_LOADING = "GET_STATE_LOADING";
export const GET_STARASSIGNMENT_SEARCHAFFILIATES = "GET_STARASSIGNMENT_SEARCHAFFILIATES";
export const GET_CARDSLIST = "GET_CARDSLIST"
export const GET_LIST_HISTORICAL_TEMPLATE = "GET_LIST_HISTORICAL_TEMPLATE";
export const GET_POST_TEMPLATE = "GET_POST_TEMPLATE";
export const GET_DOWNLOAD_TEMPLATE = "GET_DOWNLOAD_TEMPLATE";
export const GET_LIST_TYPE_STAR_LIST = "GET_LIST_TYPE_STAR_LIST";
export const GET_ZEN_STAR_REQUESTS = "GET_ZEN_STAR_REQUESTS";
export const GET_STAR_ZEN_STATUS = "GET_STAR_ZEN_STATUS";
export const GET_STATE_LOADING_STARASSIGNMENT = "GET_STATE_LOADING_STARASSIGNMENT";
export const GET_JOB_STATUS = "GET_JOB_STATUS";
